const SKELETON_KEY: InjectionKey<Ref<boolean>> = Symbol('skeleton')

export function provideSkeleton(skeletonState: Ref<boolean>) {
  provide(SKELETON_KEY, skeletonState)
}

/**
 * Hierarchical dependency injection for skeleton loading states.
 * Components can either use a local skeleton state or inherit from an ancestor.
 *
 * Local skeleton state takes precedence over the injected state.
 * The state is re-provided to child components to maintain the hierarchy.
 *
 * @param localSkeleton Optional local skeleton state as a ref, computed ref, or getter function.
 * @returns Computed reference indicating whether to show the skeleton.
 */
export function useSkeleton(localSkeleton?: MaybeRefOrGetter<boolean>): { showSkeleton: ComputedRef<boolean> } {
  const injectedSkeleton = inject(SKELETON_KEY, ref(false))
  const showSkeleton = computed(() => !!(localSkeleton ? toValue(localSkeleton) : false) || injectedSkeleton.value)
  provideSkeleton(showSkeleton)
  return { showSkeleton }
}
